<template>
	<div class="page-layout" v-loading="loading">
		<gc-header headerData="batchDirectiveManage">
			<template #ops>
				<send-command
					@update-list="updateList"
					:options="options"
					v-if="$has('monitor:run:batch-command:insert')"
				></send-command>
			</template>
		</gc-header>
		<div class="run-main directive-content">
			<div class="left" v-if="tenantType == 1">
				<GcRegionTree v-model="form.waterRegionCode" :initSelect="false" />
			</div>
			<div class="right">
				<div class="filter">
					<gc-advanced-filter
						v-model="form"
						:fields="filterFields"
						@search="handleFilterSearch"
						@reset="handleFilterReset"
					/>
					<gc-column-setting
						:storageKey="`localcolumn-batch-directive-${tenantType}`"
						:columns="columns"
						@update-column="data => (columns = data)"
					></gc-column-setting>
				</div>
				<div class="table">
					<gc-table
						:columns="columnList"
						:table-data="tableData"
						:border="true"
						:showPage="true"
						pagination-type="special"
						:page-params="pageParams"
						@current-page-change="currentPageChange"
					></gc-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { apiBatchCommandRecordsList } from '@/apis/batchDirectiveManage.api'
import deviceTypeOption from '../mixins/deviceTypeOption'
import { handleParams } from '@/utils'
import { isBlank } from '@/utils/validate'
import sendCommand from './send-command/index.vue'

export default {
	name: 'batchDirectiveManage',
	components: { sendCommand },
	mixins: [deviceTypeOption],
	data() {
		return {
			form: {
				deviceTypeIdList: [], //设备类型
				taskName: null, //指令名称
				waterRegionCode: null, //区域编码
				userType: null, //客户类型
				time: null,
			}, //筛选条件
			tableData: [],
			pageParams: {
				hasNext: false,
				idOffset: '', //下一页offset
				currentIdOffset: '', //当前请求offset
			},
			loading: false,
			columns: [],
		}
	},
	computed: {
		tenantType() {
			// 0-燃气租户 1-水务租户
			return this.$store.getters.userInfo.tenantType
		},

		columnList() {
			return this.columns.filter(o => o.selected)
		},
		userInfo() {
			return this.$store.getters.userInfo
		},
		filterFields() {
			return [
				{
					prop: 'taskName',
					label: '指令名称',
					type: 'input',
				},
				{
					prop: 'deviceTypeIdList',
					label: '设备类型',
					type: 'select',
					props: {
						searchOption: this.options.deviceTypeId,
						filterable: true,
						needAllForSearch: true,
						multiple: true,
					},
				},
				{
					prop: 'userType',
					label: '客户类型',
					type: 'select',
					props: {
						searchOption: this.options.userType,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: true,
					},
					hidden: this.tenantType !== '1',
				},
				{
					prop: 'time',
					label: '指令日期',
					type: 'date',
					props: {
						datePickerType: 'datetimerange',
					},
					hidden: this.tenantType !== '1',
				},
			].filter(item => !item.hidden)
		},
	},

	watch: {
		'form.waterRegionCode': {
			handler(val) {
				if (val) {
					this.getBatchCommandRecordsList('')
				}
			},
		},

		tenantType: {
			handler(newVal) {
				this.columns = [
					{
						key: 'deviceTypeName',
						name: '设备类型',
						fixed: 'left',
						dragDisable: true,
						disabledSelect: true,
						minWidth: 180,
						tooltip: true,
					},
					{
						key: 'cmdModelName',
						name: '指令名称',
						minWidth: 180,
						tooltip: true,
					},
					{
						key: 'userTypeName',
						name: '客户类型',
						hidden: newVal !== '1',
					},
					{
						key: 'waterRegionName',
						name: '所属区域',
						hidden: newVal !== '1',
						tooltip: true,
					},
					{
						key: 'importCount',
						name: '导入总数',
					},
					{
						key: 'importSuccessCount',
						name: '导入成功数',
					},
					{
						key: 'importFailCount',
						name: '导入失败数',
					},
					{
						key: 'createTime',
						name: '导入时间',
						minWidth: 180,
					},
					{
						key: 'createStaff',
						name: '创建人',
					},
					{
						key: 'reviewStatus',
						name: '任务审核状态',
						render: (h, row) => {
							const val = row.reviewStatus
							const statusMap = {
								0: { class: 'dot-message', text: '未审核' },
								1: { class: 'dot-success', text: '已审核' },
								2: { class: 'dot-error', text: '审核未通过' },
								3: { class: 'dot-warning', text: '已取消' },
							}
							return h(
								'span',
								{ class: isBlank(val) ? '' : statusMap[val]['class'] },
								isBlank(val) ? '--' : statusMap[val]['text'],
							)
						},
					},
					{
						key: 'reviewStaff',
						name: '审核人',
					},
					{
						key: 'reviewTime',
						name: '审核时间',
						width: 180,
					},
					{
						key: 'waitCount',
						name: '待执行数',
						render: (h, row) => {
							return h(
								'span',
								{
									style: {
										color: '#19BE6B',
									},
								},
								row.waitCount,
							)
						},
					},
					{
						key: 'successCount',
						name: '执行成功数',
					},
					{
						key: 'failCount',
						name: '执行失败数',
					},
					{
						key: 'orgName',
						name: '所属机构',
					},
					{
						key: 'oprate',
						name: '操作',
						width: 180,
						render: (h, row) => {
							//  自定义表格内容展示
							return this.$has('monitor:run:batch-command:select')
								? h(
										'el-button',
										{
											props: {
												type: 'text',
												size: 'medium',
											},
											on: {
												click: () => {
													this.$router.push({
														path: '/run/direct-detail',
														query: {
															taskNo: row.taskNo,
															commandTaskId: row.commandTaskId,
														},
													})
												},
											},
										},
										'查看详情',
								  )
								: h('span', {}, '/')
						},
						fixed: 'right',
					},
				].filter(m => !m.hidden)
			},
			immediate: true,
		},
	},
	mounted() {
		this.getBatchCommandRecordsList('')
		this.$set(this.options, 'userType', this.$store.getters?.dataList?.userType || [])
		this.tenantType == 1 && this.$set(this.form, 'waterRegionCode', this.userInfo.defaultWaterRegionCode)
	},
	methods: {
		handleFilterSearch() {
			this.getBatchCommandRecordsList('')
		},
		handleFilterReset() {
			this.getBatchCommandRecordsList('')
		},
		// 获取批量指令记录列表
		getBatchCommandRecordsList(currentIdOffset) {
			this.loading = true
			this.pageParams.currentIdOffset = currentIdOffset
			let params = {
				limit: 10,
				idOffset: this.pageParams.currentIdOffset,
			}
			if (this.form.time && this.form.time.length > 0) {
				params['startTime'] = this.form.time[0].getTime()
				params['endTime'] = this.form.time[1].getTime()
			}
			apiBatchCommandRecordsList({
				...params,
				...handleParams(this.form),
			})
				.then(res => {
					this.pageParams.hasNext = res.hasNext
					this.pageParams.idOffset = res.idOffset
					this.tableData = res.records || []
				})
				.finally(() => {
					this.loading = false
				})
		},
		// 重置
		reset() {
			this.form = this.$options.data().form
			this.getBatchCommandRecordsList('')
		},
		// 翻页
		currentPageChange(currentIdOffset) {
			this.getBatchCommandRecordsList(currentIdOffset)
		},
		// 指令下发后更新列表
		updateList() {
			this.getBatchCommandRecordsList('')
		},
	},
}
</script>
<style lang="scss" scoped>
@import '../runLayout.scss';
.directive-content {
	flex-direction: row;
	padding: 0 12px;
	.left {
		width: 300px;
		height: 100%;
		padding: 20px 8px 8px 0;
		border-right: 1px solid #f1f1f1;
		& + .right {
			padding-left: 12px;
		}
	}
	.right {
		flex: 1;
		width: 0;
		display: flex;
		height: 100%;
		flex-direction: column;
		.filter {
			display: flex;
			flex-wrap: wrap;
			padding: 12px 0;
		}
		.table {
			flex: 1;
			height: 0;
		}
	}
}
</style>
